import { BaseOntarioObstetricalFileSubSection, BaseOntarioObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/Ontario/Subcomponent/BaseOntarioObstetricalFileSubSection";
import { GestationalAgeComponent } from "@/Patient/Components/MedicalNote/ObstetricalFile/Control/GestationalAgeComponent";
import { ObstetricsCalculator } from "@/Patient/Helpers/ObstetricsCalculator";
import { OntarioObstetricalFileForm } from "@/Patient/Models/ObstetricalFile/Ontario/OntarioObstetricalFileForm";

interface OntarioObstetricalFilePostnatalHeaderProps extends BaseOntarioObstetricalFileSubSectionProps {
    patientFirstName: JSX.Element;
    patientLastName: JSX.Element;
}

class OntarioObstetricalFilePostnatalHeader extends BaseOntarioObstetricalFileSubSection<OntarioObstetricalFilePostnatalHeaderProps, null> {
    public componentWillMount(): void {
        super.componentWillMount();

        this.props.mutateModelState(s => {
            this.updateAutocompleteFields(s, !s.Postnatal.NumberOfWeeksPostPartum, !s.Postnatal.GestationalAgeAtBirth);
        });
    }

    public render(): JSX.Element {
        const postNatal = this.props.form.Postnatal;
        return (
            <div className="section border border-bottom">
                <div className="row">
                    {this.props.patientLastName}
                    {this.props.patientFirstName}
                </div>
                <div className="row row-form">
                    <div className="col-md-12 flex-display flex-space-between">
                        {this.renderSimpleField(
                            "DateOfVisitLabel",
                            this.controlRenderer.renderDateSelector({
                                value: postNatal.DateOfVisit,
                                onChange: date => this.mutateModelStateAutocompleteWithFormUpdate(form => form.Postnatal.DateOfVisit = date),
                                id: "postnatal-dateofvisit",
                                className: "width-100"
                            }),
                            "margin-md-right"
                        )}
                        {this.renderSimpleField(
                            "DateOfDeliveryLabel",
                            this.controlRenderer.renderDateSelector({
                                value: postNatal.DateOfDelivery,
                                onChange: date => this.mutateModelStateAutocompleteWithFormUpdate(form => form.Postnatal.DateOfDelivery = date),
                                id: "postnatal-dateOfDelivery",
                                className: "width-100"
                            }),
                            "margin-md-right"
                        )}
                        {this.renderSimpleField(
                            "ObstetricalFile_NumberOfWeeksPostPartumLabel",
                            this.controlRenderer.renderTextbox({
                                value: postNatal.NumberOfWeeksPostPartum?.toString() ?? "",
                                onChange: value => this.props.mutateModelState(form => form.Postnatal.NumberOfWeeksPostPartum = value ? Number(value) : null),
                                id: "postnatal-numberOfWeeksPostPartum",
                                isInteger: true,
                                isNumeric: true,
                                maxLength: 3
                            }),
                            "margin-md-right"
                        )}
                        {this.renderSimpleField(
                            "GestationalAgeAtBirthAbbrevLabel",
                            <GestationalAgeComponent
                                id="postnatal-gestationalAgeAtBirth"
                                gestationalAge={postNatal.GestationalAgeAtBirth}
                                readonly={this.props.readonly}
                                onChange={value => this.props.mutateModelState(form => form.Postnatal.GestationalAgeAtBirth = value)}
                                locale={this.locale}
                                controlRenderer={this.controlRenderer}
                            />,
                            "margin-md-right"
                        )}
                        <div style={{ width: !this.props.readonly ? "275px" : "auto" }}>
                            {this.renderSimpleField(
                                "PrimaryCareProviderLabel",
                                this.controlRenderer.renderPhysicianSearchTextbox(
                                    this.props.form.Common.FamilyPhysicianPrimaryCareProvider,
                                    (attendant, isSelected) => this.props.mutateModelState(
                                        form => form.Common.FamilyPhysicianPrimaryCareProvider = attendant,
                                        () => {
                                            if (isSelected)
                                                this.props.handleFormUpdate();
                                        }
                                    ),
                                    null,
                                    "PrimaryCareProviderLabel",
                                    49
                                )
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private mutateModelStateAutocompleteWithFormUpdate(mutation: (state: OntarioObstetricalFileForm) => void): void {
        this.props.mutateModelStateWithFormUpdate(s => {
            mutation(s);
            this.updateAutocompleteFields(s);
        });
    }

    private updateAutocompleteFields(
        form: OntarioObstetricalFileForm,
        updateNumberOfWeeksPostPartum: boolean = true,
        updateGestationalAgeAtBirth: boolean = true
    ): void {
        if (!form.Postnatal.DateOfDelivery)
            return;

        if (updateNumberOfWeeksPostPartum && form.Postnatal.DateOfVisit)
            form.Postnatal.NumberOfWeeksPostPartum = ObstetricsCalculator.calculateNumberOfWeeksPostpartum(form.Postnatal.DateOfDelivery, form.Postnatal.DateOfVisit);

        if (updateGestationalAgeAtBirth && form.Common.FinalEstimatedDateOfBirth)
            form.Postnatal.GestationalAgeAtBirth = ObstetricsCalculator.calculateWeeksOfGestation(form.Common.FinalEstimatedDateOfBirth, form.Postnatal.DateOfDelivery);
    }
}

export { OntarioObstetricalFilePostnatalHeader };
